import { render, staticRenderFns } from "./DialogOneSubtask.vue?vue&type=template&id=51413b69&scoped=true"
import script from "./DialogOneSubtask.vue?vue&type=script&lang=js"
export * from "./DialogOneSubtask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51413b69",
  null
  
)

export default component.exports